export default {
  computed:{
    currentConfig(){
      const os = this.$store.getters.otherSetting || {}
      const pw = os.pageView || {}
      const path = this.$route.path.split('/').filter(Boolean).pop()
      return pw[path] || {}
    }
  }
}